/* eslint-env jquery */
( $ => {
  $.fn.parallaxMove = function ( options ) {
    const settings = $.extend(
      {
        offset: 0,
        mobile: false,
        dir: 'top',
        headerFixed: false,
        twoWay: false,
        parentEl: 'section',
      },
      options
    );
    const currEl = this,
      wH = $( window ).height(),
      wW = $( window ).width(),
      hH = $( 'header' ).height(),
      parent = currEl.parents( `${settings.parentEl}` ),
      boundingBox = parent[0].getBoundingClientRect(),
      parentTop = boundingBox.top,
      parentBottom = boundingBox.bottom,
      speed = settings.headerFixed ? settings.offset / ( wH - hH ) : settings.offset / wH,
      inViewHeight = wH - parentTop,
      checkTwoWay = !settings.twoWay ? parentTop >= 100 : parentTop >= boundingBox.height * -1,
      scrollPortion =
        settings.dir === 'top' || settings.dir === 'right'
          ? settings.offset - inViewHeight * speed
          : ( settings.offset - inViewHeight * speed ) * -1,
      disableParallax = wW < 768 && !settings.mobile ? true : false;
    if ( parentTop <= parseInt( wH + 100 ) && parentBottom >= 0 && checkTwoWay && !disableParallax ) {
      if ( settings.dir === 'top' ) {
        currEl
          .css( {
            transform: 'translate3d(0,' + scrollPortion + 'px,0)',
          } )
          .addClass( 'parallax-init' );
      } else if ( settings.dir === 'right' ) {
        currEl
          .css( {
            transform: 'translate3d(' + scrollPortion + 'px, 0, 0)',
          } )
          .addClass( 'parallax-init' );
      }
    } else if ( !settings.twoWay && parentTop <= 0 ) {
      currEl.not( '.parallax-init' ).css( {
        transform: 'translate3d(0, 0, 0)',
      } );
    } else if ( disableParallax ) {
      currEl[0].style.removeProperty( 'transform', '-webkit-transform' );
    }
    currEl.addClass( 'parallax-item' );
  };
} )( jQuery );
const mediaElement = $( '.bs-section--about-our-philosophy .bs-div--img-wrapper .media-elements' );
$( window ).on( 'load scroll resize', () => {
  if ( $( '.bs-div--home-eco-system-logo-wrapper' ).length ) {
    $( '.bs-div--home-eco-system-logo-wrapper' ).eq( 0 ).parallaxMove( {
      mobile: true,
      offset: 150,
      dir: 'right',
      headerFixed: true,
    } );
    $( '.bs-div--home-eco-system-logo-wrapper' ).eq( 1 ).parallaxMove( {
      mobile: true,
      offset: -100,
      dir: 'right',
      headerFixed: true,
    } );
    $( '.bs-div--home-eco-system-logo-wrapper' ).eq( 2 ).parallaxMove( {
      mobile: true,
      offset: 200,
      dir: 'right',
      headerFixed: true,
    } );
    $( '.bs-div--home-eco-system-logo-wrapper' ).eq( 3 ).parallaxMove( {
      mobile: true,
      offset: -130,
      dir: 'right',
      headerFixed: true,
    } );
  }
  if ( $( '.bs-section--about-our-philosophy .bs-div--img-wrapper' ).length ) {
    mediaElement.addClass( 'full-opacity' );
    mediaElement.eq( 0 ).parallaxMove( {
      offset: -50,
      headerFixed: true,
    } );
    mediaElement.eq( 1 ).parallaxMove( {
      offset: 200,
      headerFixed: true,
    } );
  }
  if ( $( '.bs-section--pricing-counter .bs-column--pricing-post-wrapper' ).length ) {
    $( '.bs-section--pricing-counter .bs-column--pricing-post-wrapper .bs-post' ).parallaxMove( {
      offset: 70,
      dir: 'right',
      headerFixed: true,
    } );
    $( '.bs-section--pricing-counter .bs-column--pricing-post-wrapper .bs-div--post-block-wrapper' ).parallaxMove( {
      offset: -70,
      dir: 'top',
      headerFixed: true,
    } );
  }
  if ( $( '.bs-section--why-repeatable-section .bs-div--img-wrapper' ).length ) {
    $( '.bs-media-element--why-content-img-one' ).parallaxMove( {
      offset: -85,
      headerFixed: true,
      parentEl: '.bs-row'
    } );
    $( '.bs-media-element--why-content-img-two' ).parallaxMove( {
      offset: 75,
      headerFixed: true,
      parentEl: '.bs-row'
    } );
  }
  const moreLayout = $( '.bs-div--home-answers-to-questions-image-layout-more' );
  const midLayout = $( '.bs-div--home-answers-to-questions-image-layout-mid' );
  const lessLayout = $( '.bs-div--home-answers-to-questions-image-layout-less' );
  const oneLayout = $( '.bs-div--home-answers-to-questions-image-layout-one' );
  const twoLayout = $( '.bs-div--home-answers-to-questions-image-layout-two' );
  const threeLayout = $( '.bs-div--home-answers-to-questions-image-layout-three' );
  const fourLayout = $( '.bs-div--home-answers-to-questions-image-layout-four' );
  if ( moreLayout.length !== 0 ) {
    const moreLayoutImg1 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      moreLayoutImg2 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      moreLayoutImg3 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      moreLayoutImg4 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      moreLayoutImg5 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-five' ),
      moreLayoutImg6 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-six' ),
      moreLayoutImg7 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-seven' ),
      moreLayoutImg8 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-eight' ),
      moreLayoutImg9 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-nine' ),
      moreLayoutImg10 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-ten' ),
      moreLayoutImg11 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-eleven' ),
      moreLayoutImg12 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-twelve' ),
      moreLayoutImg13 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-thirteen' ),
      moreLayoutImg14 = moreLayout.find( '.bs-media-element--home-answers-to-questions-img-fourteen' );

    moreLayoutImg1.parallaxMove( {
      offset: -100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg2.parallaxMove( {
      dir: 'right',
      offset: -40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg3.parallaxMove( {
      offset: -150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg4.parallaxMove( {
      dir: 'right',
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg5.parallaxMove( {
      offset: 140,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg6.parallaxMove( {
      dir: 'right',
      offset: 40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg7.parallaxMove( {
      offset: -70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg8.parallaxMove( {
      dir: 'right',
      offset: -80,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg9.parallaxMove( {
      offset: 160,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg10.parallaxMove( {
      offset: -120,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg11.parallaxMove( {
      dir: 'right',
      offset: -60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg12.parallaxMove( {
      offset: 120,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg13.parallaxMove( {
      dir: 'right',
      offset: 70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    moreLayoutImg14.parallaxMove( {
      offset: -160,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( midLayout.length !== 0 ) {
    const midLayoutImg1 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      midLayoutImg2 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      midLayoutImg3 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      midLayoutImg4 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      midLayoutImg5 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-five' ),
      midLayoutImg6 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-six' ),
      midLayoutImg7 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-seven' ),
      midLayoutImg8 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-eight' ),
      midLayoutImg9 = midLayout.find( '.bs-media-element--home-answers-to-questions-img-nine' );

    midLayoutImg1.parallaxMove( {
      offset: -150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg2.parallaxMove( {
      dir: 'right',
      offset: 180,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg3.parallaxMove( {
      dir: 'right',
      offset: -50,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg4.parallaxMove( {
      offset: -150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg5.parallaxMove( {
      offset: 100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg6.parallaxMove( {
      offset: 70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg7.parallaxMove( {
      dir: 'right',
      offset: -60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg8.parallaxMove( {
      offset: 150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    midLayoutImg9.parallaxMove( {
      dir: 'right',
      offset: 100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( lessLayout.length !== 0 ) {
    const lessLayoutImg1 = lessLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      lessLayoutImg2 = lessLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      lessLayoutImg3 = lessLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      lessLayoutImg4 = lessLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      lessLayoutImg5 = lessLayout.find( '.bs-media-element--home-answers-to-questions-img-five' );

    lessLayoutImg1.parallaxMove( {
      offset: -150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    lessLayoutImg2.parallaxMove( {
      offset: 150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    lessLayoutImg3.parallaxMove( {
      dir: 'right',
      offset: -150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    lessLayoutImg4.parallaxMove( {
      offset: -90,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    lessLayoutImg5.parallaxMove( {
      dir: 'right',
      offset: 100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( oneLayout.length !== 0 ) {
    const oneLayoutImg1 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      oneLayoutImg2 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      oneLayoutImg3 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      oneLayoutImg4 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      oneLayoutImg5 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-five' ),
      oneLayoutImg6 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-six' ),
      oneLayoutImg7 = oneLayout.find( '.bs-media-element--home-answers-to-questions-img-seven' );

    oneLayoutImg1.parallaxMove( {
      offset: -100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    oneLayoutImg2.parallaxMove( {
      dir: 'right',
      offset: -40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    oneLayoutImg3.parallaxMove( {
      offset: 150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    oneLayoutImg4.parallaxMove( {
      dir: 'right',
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    oneLayoutImg5.parallaxMove( {
      offset: -140,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    oneLayoutImg6.parallaxMove( {
      dir: 'right',
      offset: 40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    oneLayoutImg7.parallaxMove( {
      offset: 70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( twoLayout.length !== 0 ) {
    const twoLayoutImg1 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      twoLayoutImg2 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      twoLayoutImg3 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      twoLayoutImg4 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      twoLayoutImg5 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-five' ),
      twoLayoutImg6 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-six' ),
      twoLayoutImg7 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-seven' ),
      twoLayoutImg8 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-eight' ),
      twoLayoutImg9 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-nine' ),
      twoLayoutImg10 = twoLayout.find( '.bs-media-element--home-answers-to-questions-img-ten' );

    twoLayoutImg1.parallaxMove( {
      offset: -100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg2.parallaxMove( {
      dir: 'right',
      offset: 40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg3.parallaxMove( {
      dir: 'right',
      offset: -50,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg4.parallaxMove( {
      offset: 70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg5.parallaxMove( {
      offset: -140,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg6.parallaxMove( {
      offset: 100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg7.parallaxMove( {
      dir: 'right',
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg8.parallaxMove( {
      offset: -60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg9.parallaxMove( {
      dir: 'right',
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    twoLayoutImg10.parallaxMove( {
      offset: 120,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( threeLayout.length !== 0 ) {
    const threeLayoutImg1 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      threeLayoutImg2 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      threeLayoutImg3 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      threeLayoutImg4 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      threeLayoutImg5 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-five' ),
      threeLayoutImg6 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-six' ),
      threeLayoutImg7 = threeLayout.find( '.bs-media-element--home-answers-to-questions-img-seven' );

    threeLayoutImg1.parallaxMove( {
      offset: -100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    threeLayoutImg2.parallaxMove( {
      dir: 'right',
      offset: -40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    threeLayoutImg3.parallaxMove( {
      offset: 150,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    threeLayoutImg4.parallaxMove( {
      offset: 120,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    threeLayoutImg5.parallaxMove( {
      offset: -160,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    threeLayoutImg6.parallaxMove( {
      dir: 'right',
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    threeLayoutImg7.parallaxMove( {
      dir: 'right',
      offset: -70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( fourLayout.length !== 0 ) {
    const fourLayoutImg1 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-one' ),
      fourLayoutImg2 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-two' ),
      fourLayoutImg3 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-three' ),
      fourLayoutImg4 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-four' ),
      fourLayoutImg5 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-five' ),
      fourLayoutImg6 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-six' ),
      fourLayoutImg7 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-seven' ),
      fourLayoutImg8 = fourLayout.find( '.bs-media-element--home-answers-to-questions-img-eight' );

    fourLayoutImg1.parallaxMove( {
      offset: -100,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg2.parallaxMove( {
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg3.parallaxMove( {
      dir: 'right',
      offset: -40,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg4.parallaxMove( {
      offset: -120,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg5.parallaxMove( {
      dir: 'right',
      offset: 60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg6.parallaxMove( {
      offset: -60,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg7.parallaxMove( {
      dir: 'right',
      offset: 70,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );

    fourLayoutImg8.parallaxMove( {
      offset: 80,
      headerFixed: true,
      parentEl: '.bs-tab-slider',
    } );
  }
  if ( $( '.bs-div--integrations-banner--logo-wrapper' ).length !== 0 ) {
    $( '.bs-div--integrations-banner--logo-wrapper' ).css( { opacity: '1' } );
    $( '.bs-div--integrations-banner--logo-wrapper' ).eq( 0 ).parallaxMove( {
      mobile: true,
      offset: 150,
      dir: 'right',
      headerFixed: true,
      twoWay: true,
    } );
    $( '.bs-div--integrations-banner--logo-wrapper' ).eq( 1 ).parallaxMove( {
      mobile: true,
      offset: -100,
      dir: 'right',
      headerFixed: true,
      twoWay: true,
    } );
    $( '.bs-div--integrations-banner--logo-wrapper' ).eq( 2 ).parallaxMove( {
      mobile: true,
      offset: 170,
      dir: 'right',
      headerFixed: true,
      twoWay: true,
    } );
    $( '.bs-div--integrations-banner--logo-wrapper' ).eq( 3 ).parallaxMove( {
      mobile: true,
      offset: -130,
      dir: 'right',
      headerFixed: true,
      twoWay: true,
    } );
  }
} );
